export default __webpack_public_path__ + "static/sa-a70b16aaa9f75d82b88814f86d01402e.svg";